import { render, staticRenderFns } from "./EmployeeRetention.vue?vue&type=template&id=078dc4c4&scoped=true&"
import script from "./EmployeeRetention.vue?vue&type=script&lang=js&"
export * from "./EmployeeRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078dc4c4",
  null
  
)

export default component.exports